module.exports = __webpack_public_path__ + "static/img/image-birds.eca02a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/image-birds.jpg
// module id = 207
// module chunks = 0